export default {
  showMore: 'Show %{count} more',
}
